import { LOAD_ELIGABLE_HOURS_SUCCESS, CLEAR_ELIGABLE_HOURS } from "../actions/ActionTypes";

// Assuming this is your initial state
const initialState = [];

export default function eligableHoursReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ELIGABLE_HOURS_SUCCESS:
      return action.payload || [];
    case CLEAR_ELIGABLE_HOURS:
      return initialState; // Reset to empty array
    default:
      return state;
  }
}
